(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_b6eefa2"] && !Shopify.designMode) return;
  try {
    /* Rispetta "riduci movimento": niente autoplay dei video per chi lo ha attivato nel sistema */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('video.ai-split-banner-video').forEach(function (video) {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.pause();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
